/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import dayjs from "dayjs";
import Config from "data/config";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { formatBytes } from "utils/format-bytes";
import { isValidGuid } from "utils/empty-exists";
import { Button } from "@mui/material";
import { ModeEditOutlineOutlined as ModeEditOutlineOutlinedIcon } from "@mui/icons-material";

// function formatDate (date, tz) {
function formatDate (date) {
    return dayjs(date).format(Config.dates.display.datetime);
}

const DocumentDialogPreviewPanel = () => {

    const {
        selectedDocument,
        setOpenEdit,
    } = useContext(DocumentEditContext);
    const hasDocument = isValidGuid(selectedDocument?.guid);

    const handleEdit = () => {
        setOpenEdit(true);
    };

    return (
        <Fragment>
            {!hasDocument &&
                <div className="simplicity-document-selector-window-preview-none">
                    <div className="simplicity-document-selector-edit">
                        <div className="doc-details-header header">
                            <div className="doc-details-header-text">
                                Details
                            </div>
                        </div>
                        <div className="doc-details-body">
                            No document selected
                        </div>
                    </div>
                </div>
            }
            {hasDocument &&
                <div className="simplicity-document-selector-window-preview">
                    <div className="simplicity-document-selector-edit">


                        <div className='doc-details-header'>
                            <div className='doc-details-header-text'>
                                Details
                            </div>
                        </div>

                        <div className="doc-details-body">
                            {selectedDocument &&
                                <Fragment>
                                    <div><b>Filename:</b> {selectedDocument.file_name}</div>
                                    <div><b>Type:</b> {selectedDocument.file_type}</div>
                                    <div><b>Extension:</b> {selectedDocument.file_ext}</div>
                                    <div><b>Size:</b> {formatBytes(selectedDocument.file_size)}</div>
                                </Fragment>
                            }
                        </div>

                        <div className='doc-details-header'>
                            <div className='doc-details-header-text'>
                                Dates
                            </div>
                        </div>

                        <div className="doc-details-body">
                            {selectedDocument &&
                                <Fragment>
                                    <div><b>Created:</b> {formatDate(selectedDocument.created_at)}</div>
                                    <div><b>Updated:</b> {formatDate(selectedDocument.updated_at)}</div>
                                </Fragment>
                            }
                        </div>
                        <div className='doc-details-header'>
                            <div className='doc-details-header-text'>
                                Actions
                            </div>
                        </div>

                        <div className="doc-details-body">
                            <div className='simplicity-document-selector-button'>
                                {selectedDocument &&
                                    <Button
                                        variant='outlined'
                                        color='secondary'
                                        size='small'
                                        onClick={handleEdit}
                                        startIcon={<ModeEditOutlineOutlinedIcon color='secondary'/>}
                                    >
                                        Edit
                                    </Button>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            }
        </Fragment>
    );
};

export { DocumentDialogPreviewPanel };
